import React from "react";
import PropTypes from "prop-types";
import { managementStatusLabels } from "../../../config/mgmtDataConfig";
import { Tooltip } from "@mui/material";

const TableCell = React.memo(
  ({ field, managementCompany, handleIdClick, width }) => {
    // Determine the display value. For statusId, use a label mapping if available.
    const displayValue =
      field.key === "statusId"
        ? managementStatusLabels[managementCompany[field.key]] ||
          managementCompany[field.key]
        : managementCompany[field.key];

    // Use a fallback if displayValue is null or undefined.
    const finalDisplay = displayValue ?? "-";

    const contentStyle = {
      display: "inline-block",
      width: width,
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    };

    const content = <span style={contentStyle}>{finalDisplay}</span>;

    // For the managementId cell, enable a clickable behavior that triggers the dedicated id click handler.
    if (field.key === "companyName") {
      return (
        <td
          className="px-4 py-1 cursor-pointer text-sss-info"
          onClick={(e) => {
            e.stopPropagation();
            if (handleIdClick) {
              handleIdClick(managementCompany);
            }
          }}
        >
          <Tooltip
            title={`Open Management Company ${managementCompany[field.key]}`}
            enterDelay={1000}
          >
            {content}
          </Tooltip>
        </td>
      );
    }

    return (
      <td className="px-4 py-1">
        <Tooltip title={finalDisplay}>{content}</Tooltip>
      </td>
    );
  }
);

TableCell.propTypes = {
  field: PropTypes.object.isRequired,
  managementCompany: PropTypes.object.isRequired,
  handleIdClick: PropTypes.func,
  width: PropTypes.number.isRequired,
};

export default TableCell;
